<template>
  <Popup :isShow="isShow" :preventTouchMove="false">
    <div v-if="isShow" class="questionaire-wrapper">
      <div v-if="showPreGuide" class="tips-wrapper">
        <div class="tips-wrap">
          <div class="title">{{ title }}</div>
          <div class="desc">
            {{ desc }}
          </div>
        </div>
        <div class="line" />
      </div>

      <!-- 问卷说明 -->
      <ques-list
        class="content-wrapper"
        :surveyCode="surveyCode"
        :showProgressText="false"
        @refresh="handleRefresh"
        @updateIndex="updateIndex"
        @updateHeader="updateHeader"
      />
    </div>
  </Popup>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Popup from '@component/Popup/';
import PreGuide from './PreGuide.vue';
import QuesList from './QuesList.vue';

@Component({
  components: {
    Popup,
    PreGuide,
    QuesList,
  },
})
export default class QuestionnairePy extends Vue {
  @Prop({ type: Boolean }) isShow!: boolean;
  @Prop({ type: String, default: '' }) surveyCode!: string;

  showPreGuide = true;
  title = '';
  desc = '';

  @Watch('isShow')
  init() {
    const index = localStorage.getItem(`${this.surveyCode}`);
    if (index) {
      this.showPreGuide = false;
    }
  }

  updateIndex(index: number) {
    if (index !== 0 && this.showPreGuide) {
      this.showPreGuide = false;
    }
  }
  updateHeader(title: string, desc: string) {
    title && (this.title = title);
    desc && (this.desc = desc);
  }

  handleRefresh() {
    this.$emit('refresh');
  }
}
</script>

<style lang="scss" scoped>
$theme-color: #382d68;
$theme-active: #377ef9;
.questionaire-wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  padding: 42px 0;
}
.tips-wrapper {
  margin: 0 42px;

  .tips-wrap {
    width: 666px;
    height: 222px;
    padding: 32px 56px;
    text-align: center;
    // background-color: #f5f5fb;
    background-image: url(https://res.pandateacher.com/4UGTBW511628156562143.png);
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 8px;
  }
  .line {
    height: 0px;
    margin: 42px 0;
    border-top: 1px solid #e9e9f3;
  }

  .title {
    color: $theme-color;
    font-weight: 600;
    font-size: 30px;
  }
  .desc {
    margin-top: 24px;
    color: $theme-color;
    font-size: 28px;
    line-height: 46px;
  }
}
.content-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  // height: 100%;
  // overflow: hidden;
  overflow-y: scroll;
  // overflow-x: hidden;
}
</style>
